import React from 'react';
import { PageHead } from '../../Layout';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '../../Theme';
import { getTemplateSocialCardUrl } from '../socialCard';
import { HelpList } from '../../Help/HelpList';
import { articleUrl } from '../../Help/util';
import { Box } from '../../ui';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HelpArticleTemplate = function HelpArticleTemplate(_ref) {
  var template = _ref.template,
      category = _ref.category,
      article = _ref.article;
  var t = useT();
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: lightTheme,
    children: [/*#__PURE__*/_jsx(PageHead, {
      title: "".concat(t('FRODOR_1d93a2', 'Help', ''), " - ").concat(article.question),
      description: article.question,
      image: getTemplateSocialCardUrl(template),
      canonicalUrl: articleUrl(article)
    }), /*#__PURE__*/_jsx(Box, {
      noPadding: true,
      children: /*#__PURE__*/_jsx(HelpList, {
        faqCategories: template.faqCategories || [],
        currentCategory: category,
        currentArticle: article
      })
    })]
  });
};